import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { GenericInputSlotComponent } from './generic-input-slot.component';

export * from './generic-input-slot.component';

@NgModule({
    declarations: [ GenericInputSlotComponent ],
    imports: [
        CommonModule,
        MatIconModule,
    ],
    exports: [
        GenericInputSlotComponent,
    ],
})
export class GenericInputSlotModule {
}
